module.exports = __webpack_public_path__ + "img/switch_tab.35895599.svg";